import { createFileRoute } from '@tanstack/react-router'
import { HelpCenter } from '@/features/public-site/help-center'

export const Route = createFileRoute('/help/')({ component: HelpCenter })
